module.exports = __webpack_public_path__ + "img/3.0eb6e23a.jpeg";